<div class="card card-statistics mb-30" *ngIf="Data_Seleted_Customer.id==0">
  <div class="card-body">
    <div class="float-left">
      <h5 class="card-title">
        انتخاب نامه مشتری جهت ثبت اطلاعات دریافت دستگاه
        <span *ngIf="Procssing_LetterRequestCustomer">(در حال دریافت اطلاعات ...)</span>
      </h5>
    </div>
    <div class="float-right">
      <select class="custom-select" (change)="ReadData_LetterRequestCustomer()"
        [(ngModel)]="Show_Draft_LetterRequestCustomer" name="Show_Draft_LetterRequestCustomer">
        <option value="0">نامه های فعال</option>
        <option value="1">نامه های بایگانی</option>
      </select>
    </div>

    <div style="clear: both;"></div>

    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">نام مشتری</label>
        <input [(ngModel)]="Filter_CustomerName" name="Filter_CustomerName" type="text" class="form-control"
          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> شماره نامه </label>
        <input [(ngModel)]="Filter_LetterCode" name="Filter_LetterCode" type="text" class="form-control"
          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>

    </div>


    <div class="row">
      <div class="col-md-4 mb-30" *ngFor="let item of DataList_LetterRequestCustomer
            |filter:Filter_CustomerName:'customer'
            |filter:Filter_LetterCode:'code'">

        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title"> شماره نامه '{{item.code}}' </h5>
            <h6> {{item.customer}} </h6>
            <p> تعداد دستگاه های نامه : {{item.deviceCount[0]}} عدد </p>
            <p> تعداد دستگاه های رسید نشده : {{item.deviceCount[1]}} عدد </p>
            <p *ngIf="Show_Draft_LetterRequestCustomer=='1'"> توضیحات : {{item.lastOrder}} </p>
            <hr>
            <button (click)="Set_Selected_LetterRequestCustomer(item)" type="button" class="btn btn-info"
              style="margin-left: 5px;"><i class="fa fa-plus-circle"></i> ثبت رسید </button>
            <button (click)="openModal_DraftClibrationReception(templateDraftClibration,item)"
              *ngIf="Show_Draft_LetterRequestCustomer=='0'" type="button" class="btn btn-danger"><i
                class="fa fa-save"></i> بایگانی </button>
            <button (click)="ChangeDraftClibrationReception(item)"
              *ngIf="Show_Draft_LetterRequestCustomer=='1' && item.deviceCount[1]>0" type="button"
              class="btn btn-danger"><i class="fa  fa-undo"></i> فعال سازی </button>
          </div>
        </div>
      </div>
    </div>

    <button (click)="OnSet_Back_CalibrationList()" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> بازگشت </button>




  </div>
</div>

<div class="card card-statistics mb-30" *ngIf="Data_Seleted_Customer.id>0">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات دریافت دستگاه</h5>

    <div>
      <form [formGroup]="EdCustomer">
        <br />
        <br />
        <div class="row">
          <div class="form-group col-md-2">
            <label for="exampleInputEmail1"> شماره درخواست نامه </label>
            <input type="text" class="form-control" disabled value="{{Selected_DataList_LetterRequestCustomer.id}}" />
          </div>
          <div class="form-group col-md-2">
            <label for="exampleInputEmail1"> شماره رسید </label>
            <input type="text" class="form-control" disabled value="{{Calibration_Form_Code}}" />
          </div>

          <div class="form-group col-md-8">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input style="font-weight: bolder;" type="text" class="form-control" disabled
              value="{{Data_Seleted_Customer.name}}" />
          </div>
        </div>

        <div class="row" style="display: none;">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">شماره تلفن همراه (بدون صفر اول) </label>
            <input type="number" formControlName="ModirAmelMobile" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_ModirAmelMobile().valid && get_Form_ModirAmelMobile().touched"
              class="form-text text-muted MyErrorRedColor">شماره تلفن همراه را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">تلفن</label>
            <input type="number" formControlName="ModirAmelTel" class="form-control" placeholder="اینجا تایپ کنید ...">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">داخلی</label>
            <input type="number" formControlName="ModirAmelDakheli" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">ایمیل</label>
            <input type="email" formControlName="ModirAmelEmail" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_ModirAmelEmail().valid && get_Form_ModirAmelEmail().touched"
              class="form-text text-muted MyErrorRedColor">ایمیل را وارد نمائید.</small>
          </div>
        </div>
      </form>
      <br />
      <hr />
      <br />

      <app-CutomerKarshnas [inner_Customer]="Data_Seleted_Customer.id">
      </app-CutomerKarshnas>

      <br />
      <hr />
      <br />

      <div>

        <h5> پیام های نامه </h5>

        <br />

        <form [formGroup]="MailMessageForm" (submit)="MailMessageForm_Submit()">

          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> پیام نامه </label>
              <select class="custom-select" formControlName="mailmessage_id">
                <option value="0">انتخاب کنید</option>
                <option *ngFor="let item of DataList_MailMessage" [value]="item.id">{{item.title}}</option>
              </select>
            </div>
          </div>

          <button type="submit" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i>
            افزودن پیام </button>

        </form>

        <br />
        <br />

        <div class="table-responsive" *ngIf="FormAdded_MailMessage.length>0">


          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>پیام نامه</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of FormAdded_MailMessage">
                <td>{{FormAdded_MailMessage.indexOf(item)+1}}</td>
                <td>{{item.title}}</td>
                <td style="cursor: pointer;">
                  <a style="cursor: pointer;" (click)="MailMessageForm_Delete(FormAdded_MailMessage.indexOf(item))"
                    class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                </td>
              </tr>
            </tbody>
          </table>




        </div>

        <br />
        <br />

      </div>

      <br />
      <hr />
      <br />


      <h5> دستگاه </h5>

      <form>
        <br />
        <br />
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_Device(templateDevice,-1)"
                class="btn btn-danger left"> انتخاب دستگاه <i class="fa  fa-simplybuilt"></i> </button> </label>

          </div>
        </div>

      </form>

      <br />
      <br />

      <div class="table-responsive" *ngIf="Data_List_Calibration.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام دستگاه</th>
              <th>کد دستگاه</th>
              <th>سریال دستگاه</th>
              <th>تاریخ ثبت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of Data_List_Calibration">
              <tr>
                <td rowspan="2">{{Data_List_Calibration.indexOf(item)+1}}</td>
                <td class="EnglishClm">{{item.device_name}}</td>
                <td>
                  <p class="EnglishClm" *ngIf="item.canEditDetail==1">{{item.device_code}}</p>
                  <input class="EnglishClm"  type="text" style="width: 70px;" *ngIf="item.canEditDetail==0" [(ngModel)]="item.device_code">
                </td>
                <td>
                  <p class="EnglishClm" *ngIf="item.canEditDetail==1">{{item.device_serial}}</p>
                  <input class="EnglishClm"  type="text" style="width: 70px;" *ngIf="item.canEditDetail==0"
                    [(ngModel)]="item.device_serial">
                </td>

                <td>{{item.persianDate}}</td>
                <td>
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;"
                          (click)="openModal_Device(templateDevice,Data_List_Calibration.indexOf(item))"
                          class="dropdown-item"><i class="fa  fa-simplybuilt"></i> ادغام دستگاه </a>

                        <a style="cursor: pointer;" *ngIf="!OnSubmitForm_Finish && item.canEditDetail==0"
                          (click)="Delete_List_Calibration(Data_List_Calibration.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>


                        <a style="cursor: pointer;" *ngIf="!item.visible  && item.id>0"
                          (click)="Visible_List_Calibration(item)" class="dropdown-item"><i
                            class="fa fa fa-eye-slash"></i> عدم مشاهده </a>
                        <a style="cursor: pointer;" *ngIf="item.visible  && item.id>0"
                          (click)="Visible_List_Calibration(item)" class="dropdown-item"><i class="fa fa-eye"></i>
                          مشاهده </a>

                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>توضیحات</th>
                <td colspan="2">
                  <p class="EnglishClm" *ngIf="item.canEditDetail==1">{{item.dsc}}</p>
                  <input class="EnglishClm" type="text" *ngIf="item.canEditDetail==0" [(ngModel)]="item.dsc">
                </td>
                <th>محل استقرار</th>
                <td>
                  <p class="EnglishClm" *ngIf="item.canEditDetail==1">{{item.asteghrar}}</p>
                  <input class="EnglishClm" (keyup)="setAsteghrar(item)" type="text" *ngIf="item.canEditDetail==0"
                    [(ngModel)]="item.asteghrar">
                </td>
              </tr>

              <ng-container *ngFor="let itemchild of item.child">

                <tr style="background: #e6d296;">
                  <td rowspan="2">{{item.child.indexOf(itemchild)+1}}</td>
                  <td class="EnglishClm">{{itemchild.device_name}}</td>
                  <td>
                    <p class="EnglishClm">{{item.device_code}}</p>
                  </td>
                  <td>
                    <p class="EnglishClm">{{item.device_serial}}</p>
                  </td>
                  <td>{{itemchild.persianDate}}</td>
                  <td>
                    <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                      <div class="btn-group" role="group">
                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                          <a style="cursor: pointer;" *ngIf="!OnSubmitForm_Finish && itemchild.canEditDetail==0"
                            (click)="Delete_List_CalibrationChild(item.child.indexOf(itemchild),Data_List_Calibration.indexOf(item))"
                            class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>


                          <a style="cursor: pointer;" *ngIf="!item.visible  && item.id>0"
                            (click)="Visible_List_Calibration(item)" class="dropdown-item"><i
                              class="fa fa fa-eye-slash"></i> عدم مشاهده </a>
                          <a style="cursor: pointer;" *ngIf="item.visible  && item.id>0"
                            (click)="Visible_List_Calibration(item)" class="dropdown-item"><i class="fa fa-eye"></i>
                            مشاهده </a>

                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr style="background: #e6d296;">
                  <th>توضیحات</th>
                  <td colspan="2">
                    <p class="EnglishClm" *ngIf="item.canEditDetail==1">{{item.dsc}}</p>
                    <input class="EnglishClm" type="text" *ngIf="item.canEditDetail==0" [(ngModel)]="item.dsc">
                  </td>
                  <th>محل استقرار</th>
                  <td>
                    <p class="EnglishClm" *ngIf="item.canEditDetail==1">{{item.asteghrar}}</p>
                    <input class="EnglishClm" (keyup)="setAsteghrar(item)" type="text" *ngIf="item.canEditDetail==0"
                      [(ngModel)]="item.asteghrar">
                  </td>
                </tr>
              </ng-container>

            </ng-container>



          </tbody>
        </table>
      </div>

      <br />
      <hr />
      <br />

      <h5> گیرنده گواهی نامه </h5>

      <button type="button" (click)="openModal_Customer(templateCustomer,1)" class="btn btn-warning"
        style="margin-left: 5px;"> جستجوی مشتری <i class="fa fa-vcard"></i> </button>
      <form>
        <br />
        <br />
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">کد مشتری </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_ReciveCustomer.code}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_ReciveCustomer.name}}" />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> توضیحات گیرنده گواهی نامه </label>
            <input type="text" class="form-control" placeholder="اینجا تایپ کنید ..."
              [(ngModel)]="Data_Seleted_ReciveCustomer_Dsc" name="Data_Seleted_ReciveCustomer_Dsc" />
          </div>
        </div>

      </form>

      <br />
      <hr />
      <br />

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> تحویل دهنده </label>
          <input type="text" class="form-control" placeholder="اینجا تایپ کنید ..."
            [(ngModel)]="Calibration_Form_TahvilDahandeh" name="Calibration_Form_TahvilDahandeh" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> توضیحات رسید </label>
          <input type="text" class="form-control" placeholder="اینجا تایپ کنید ..." [(ngModel)]="Calibration_Form_Dsc"
            name="Calibration_Form_Dsc" />
        </div>
      </div>

    </div>



    <br />
    <br />
    <br />


    <button *ngIf="Data_Seleted_Customer.id>0 && !Proccesing_SubmitForm && !OnSubmitForm_Finish"
      (click)="openModal_FinishForm(templateFinishForm)" type="button" class="btn btn-info" style="margin-left: 5px;"><i
        class="fa  fa-plus"></i> تایید و نهایی ثبت اطلاعات </button>
    <button *ngIf="Data_Seleted_Customer.id>0 && !Proccesing_SubmitForm && !OnSubmitForm_Finish"
      (click)="OnSubmitForm(0,templateCode)" type="button" class="btn btn-success" style="margin-left: 5px;"><i
        class="fa  fa-plus"></i> ذخیره اطلاعات </button>
    <button *ngIf="Proccesing_SubmitForm" type="button" class="btn btn-info" style="margin-left: 5px;"> لطفا صبر نمائید
      ... <i class="fa fa-spin fa-spinner"></i> </button>

    <a *ngIf="Calibration_Form_Id>0" href="{{BaseUrl}}{{Calibration_Form_Id}}" target="_blank"
      style="margin-left: 5px;"> <button type="button" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> چاپ
        اطلاعات </button> </a>
    <a *ngIf="Calibration_Form_Id>0" href="{{BaseUrl2}}{{Calibration_Form_Id}}" target="_blank"
      style="margin-left: 5px;"> <button type="button" class="btn btn-info"><i class="fa fa-file-pdf-o"></i> چاپ تجمیعی
        اطلاعات </button> </a>
    <!--
    <a *ngIf="Calibration_Form_Id>0" href="{{PrintURl}}{{Calibration_Form_Id}}" target="_blank"
      style="margin-left: 5px;"> <button type="button" class="btn btn-danger"><i class="fa fa-qrcode"></i> QR Code
      </button> </a>
    -->
    <a *ngIf="Calibration_Form_Id>0" href="{{PrintURl2}}{{Calibration_Form_Id}}" target="_blank"
      style="margin-left: 5px;"> <button type="button" class="btn btn-warning"><i class="fa fa-qrcode"></i> QR Code (A5)
      </button> </a>

    <button (click)="Change_Visible_Karshnas()" *ngIf="visible_karshnas" type="button" class="btn btn-success"
      style="margin-left: 5px;">
      <i class="fa fa-eye"></i> نمایش اطلاعات کارشناس در PDF
    </button>

    <button (click)="Change_Visible_Karshnas()" *ngIf="!visible_karshnas" type="button" class="btn btn-danger"
      style="margin-left: 5px;">
      <i class="fa fa-eye-slash"></i> عدم نمایش اطلاعات کارشناس در PDF
    </button>

    <button (click)="OnSet_Back_CalibrationList()" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> بازگشت </button>
  </div>
</div>



<ng-template #templateCustomer>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات مشتری </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Customer.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" (keyup)="ReadData_Customer_KeySearch()" class="form-control"
            [(ngModel)]="Search_CodeName_Customer_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد مشتری بهفا</th>
              <th>نام مشتری</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Customer
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Customer).length
                      }">
              <td>{{DataList_Customer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.name}}</td>
              <td (click)="Set_Selected_Customer_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingCustomer" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingCustomer" type="button" (click)="ReadData_Customer()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات دستگاه های نامه '{{Selected_DataList_LetterRequestCustomer.id}}'
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> دستگاه لاتین </label>
          <input type="text" class="form-control" [(ngModel)]="Search_Name_Device_Table"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th (click)="ChangeOrder('device_name_en')">
                <i *ngIf="order=='device_name_en' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='device_name_en' && orderreverse" class="fa fa-sort-up"></i>
                دستگاه لاتین
              </th>
              <th (click)="ChangeOrder('device_name')">
                <i *ngIf="order=='device_name' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='device_name' && orderreverse" class="fa fa-sort-up"></i>
                دستگاه فارسی
              </th>
              <th (click)="ChangeOrder('deviceSerial')">
                <i *ngIf="order=='deviceSerial' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='deviceSerial' && orderreverse" class="fa fa-sort-up"></i>
                سریال دستگاه
              </th>
              <th (click)="ChangeOrder('deviceCode')">
                <i *ngIf="order=='deviceCode' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='deviceCode' && orderreverse" class="fa fa-sort-up"></i>
                کد دستگاه
              </th>
              <th>نقطه یا گستره‌ی مورد نیاز</th>
              <th>توضیحات</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device_Filtered
                  |filter:Search_Name_Device_Table:'device_name_en'
                  | orderBy: order : orderreverse">
              <td>{{DataList_Device_Filtered.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.device_name_en}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.deviceSerial}}</td>
              <td>{{item.deviceCode}}</td>
              <td>{{item.gostareh}}</td>
              <td>{{item.deviceCustomerDsc}}</td>

              <td (click)="Set_Selected_Device_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingDevice" type="button" (click)="ReadData_Device()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> شماره رسید </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>شماره رسید فرم کالبیراسیون در محل تجهیزات <b>'{{Calibration_Form_Code}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateFinishForm>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> تایید ثبت نهایی اطلاعات </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_FinishForm.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>آیا شما از تعداد کالیبراسیون تجهیزاتی که ثبت کرده اید ، مطمئین هستید؟</p>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Customer.id>0 && !Proccesing_SubmitForm && !OnSubmitForm_Finish"
      (click)="OnSubmitForm(1,templateCode)" type="button" class="btn btn-info" style="margin-left: 5px;"><i
        class="fa  fa-plus"></i> تایید و نهایی ثبت اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_FinishForm.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateDeviceBefa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات دستگاه بهفا </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBefa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Code BEHFA </label>
          <input type="text" class="form-control" [(ngModel)]="Filter_Behfa_Item"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Group</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Certificate No.</th>
              <th>Cal. Due</th>
              <th>تاریخ دریافت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            |filter:Filter_Behfa_Item:'codeBEHFA'
            | paginate
                    : {
                        id: 'DataList_DeviceBehfaId',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfa|filter:Filter_Behfa_Item:'codeBEHFA').length
                      }">
              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td>{{item.groupTitle}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td class="EnglishClm">{{item.certificateNo}}</td>
              <td class="EnglishClm">{{item.calDue}}</td>
              <td>{{item.downloadDate}}</td>
              <td (click)="Set_Selected_DeviceBefa_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingDevice" type="button" (click)="ReadData_DeviceBehfa()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBefa.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateDraftClibration>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> بایگانی شماره نامه '{{Selected_DataList_LetterRequestCustomerDraft.code}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close"
      (click)="modalRef_DraftClibrationReception.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input type="text" class="form-control" name="DraftClibrationReceptionDsc"
          [(ngModel)]="DraftClibrationReceptionDsc" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="ChangeDraftClibrationReceptionModal()"> ارسال و ثبت </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DraftClibrationReception.hide()">بستن</button>
  </div>
</ng-template>